<template>
    <svg
        id="fi_2311524"
        enable-background="new 0 0 32 32"
        height="512"
        viewBox="0 0 32 32"
        width="512"
        xmlns="http://www.w3.org/2000/svg">
        <path
            id="XMLID_294_"
            d="m13 16c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z"></path>
        <path
            id="XMLID_295_"
            d="m13 26c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z"></path>
        <path
            id="XMLID_297_"
            d="m13 6c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z"></path>
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
